<template>
  <div class="container">
    <!-- 面包屑 -->
    <!-- 卡片容器 -->
    <el-card class="general-card" style="padding: 20px;">
      <!-- 统计面板 -->
      <el-row :gutter="16" class="panel" style="margin-bottom: 20px;">
        <el-col
          v-for="(item, idx) in links"
          :key="item.title"
          :span="6"
          class="panel-col"
        >
          <el-row :gutter="12" class="panel-item" style="display: flex; align-items: center; cursor: pointer;">
            <el-col :span="6">
              <el-avatar :size="48" class="col-avatar">
                <img :src="item.img" alt="avatar" style="width: 100%; height: 100%; object-fit: contain;">
              </el-avatar>
            </el-col>
            <el-col :span="18">
              <div class="statistic-container">
                <div class="statistic-title">{{ item.title }}</div>
                <div class="statistic-value">
                  <countTo
                    :start-val="0"
                    :end-val="item.value"
                    :duration="2000"
                    :precision="item.precision || 0"
                    :separator="','"
                  ></countTo>
                  <span class="unit">{{ item.unit }}</span>
                  <i class="el-icon-caret-top up-icon" v-if="idx === 0"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- 分割线 -->
      <el-divider class="panel-border"></el-divider>

      <!-- 搜索表单 -->
      <el-form :model="formModel" :inline="true" label-position="right" class="search-form" style="margin: 20px 0;">
        <el-row :gutter="16">
            <el-form-item label="老人姓名">
              <el-input
                v-model="formModel.oldmanName"
                placeholder="请输入老人姓名"
                style="width: 240px;"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="安装位置">
              <el-input
                v-model="formModel.location"
                placeholder="请输入安装位置"
                style="width: 240px;"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" icon="el-icon-search" @click="fetchData">
                查询
              </el-button>
              <el-button type="warning" @click="resetForm" style="margin-left: 8px;">
                重置
              </el-button>
            </el-form-item>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="renderData"
        border
        :fit="true"
        style="width: 100%;"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <!-- 姓名信息列 -->
        <el-table-column
          label="姓名信息"
          align="left"
          fixed="left"
          :width="220"
        >
          <template slot-scope="scope">
            <el-row :gutter="8" style="display: flex; align-items: center;">
              <el-col :span="6">
                <el-avatar :style="{ backgroundColor: '#14C9C9', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                  <i class="el-icon-user" v-if="scope.row.sex === 0" :style="{ fontSize: '20px', color: '#fff' }"></i>
                  <i class="el-icon-woman" v-else :style="{ fontSize: '20px', color: '#fff' }"></i>
                </el-avatar>
              </el-col>
              <el-col :span="18">
                <div style="line-height: 1.5;">
                  <div style="height: 22px; margin-bottom: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ scope.row.oldmanName }}
                    <el-tag :type="scope.row.sex === 1 ? 'danger' : 'primary'" style="margin-left: 5px; font-size: 12px; padding: 2px 4px;">
                      {{ scope.row.sex === 0 ? '男' : '女' }}
                    </el-tag>
                    <el-tag type="success" style="margin-left: 5px; font-size: 12px; padding: 2px 4px;">
                      {{ scope.row.age || '--' }}岁
                    </el-tag>
                  </div>
                  <div style="font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.oldIdCard || '--' }}</div>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <!-- 安装位置列 -->
        <el-table-column
          label="安装位置"
          align="center"
          prop="location"
          :width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.location || '--' }}
          </template>
        </el-table-column>

        <!-- 设备数量列 -->
        <el-table-column
          label="设备数量"
          align="center"
          :width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.commonDeviceVos ? scope.row.commonDeviceVos.length : 0 }}
          </template>
        </el-table-column>

        <!-- 绑定设备列 -->
        <el-table-column
          label="绑定设备"
          align="left"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.commonDeviceVos && scope.row.commonDeviceVos.length > 0">
              <el-tag
                v-for="(item2, index) in scope.row.commonDeviceVos"
                :key="index"
                :type="getTagType(index)"
                style="margin-bottom: 4px; margin-right: 4px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                :title="item2"
              >
                {{ item2 }}
              </el-tag>
            </div>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          :width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="editItem(scope.row)"
              style="border: 1px solid #409EFF; color: #409EFF; border-radius: 4px; padding: 2px 8px;"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="jumpPage"
        :current-page="formModel.pageNum"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="formModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalData"
        style="margin-top: 16px; text-align: right;"
        v-if="totalData > 0"
      ></el-pagination>

      <!-- 空状态 -->
      <div v-else class="empty-state" style="text-align: center; padding: 40px 0;">
        <el-empty description="暂无相关数据"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ElMessage } from 'element-ui';
import countTo from 'vue-count-to';

export default {
  name: 'deviceMonitorList',
  components: {
    countTo
  },
  data() {
    return {
      // 表单模型
      formModel: {
        oldmanName: '',
        location: '',
        pageNum: 1,
        pageSize: 5
      },
      // 统计面板数据
      links: [
        {
          title: '设备覆盖人数',
          img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/288b89194e657603ff40db39e8072640.svg~tplv-49unhts6dw-image.image',
          value: 0,
          unit: '人'
        },
        {
          title: '设备总数',
          value: 0,
          img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/fdc66b07224cdf18843c6076c2587eb5.svg~tplv-49unhts6dw-image.image',
          unit: '台'
        },
        {
          title: '在线设备数',
          value: 0,
          img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/c8b36e26d2b9bb5dbf9b74dd6d7345af.svg~tplv-49unhts6dw-image.image',
          unit: '台'
        },
        {
          title: '在线设备率',
          value: 0,
          img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/c8b36e26d2b9bb5dbf9b74dd6d7345af.svg~tplv-49unhts6dw-image.image',
          unit: '%'
        }
      ],
      // 表格数据
      renderData: [],
      // 总数据量
      totalData: 0,
      // 加载状态
      loading: false,
      // tag类型映射（element-ui tag类型）
      tagTypes: [
        'danger', 'purple', 'warning', 'primary', 'info',
        'orange', 'gold', 'success', 'cyan', 'blue', 'magenta', 'pink'
      ]
    };
  },
  mounted() {
    // 初始化加载所有数据
    this.fetchAllData();
  },
  methods: {
    // 获取tag类型
    getTagType(index) {
      return this.tagTypes[index % this.tagTypes.length];
    },
    // 查看详情
    editItem(record) {
        this.$router.push({ path: "/deviceManager", query: { oldmanName: record.oldmanName } }); //编程式导航跳转  query传参
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.formModel.pageSize = val;
      this.formModel.pageNum = 1; // 重置为第一页
      this.fetchData();
    },

    // 页码改变
    jumpPage(val) {
      this.formModel.pageNum = val;
      this.fetchData();
    },
    getSexFromIdCard(idCard){
        if (!idCard || idCard.length !== 18) {
          throw new Error('Invalid ID card number');
        }
        const sexCode = idCard.charAt(16);
        return sexCode % 2 === 0 ? 1 : 0;
    },
    getAgeFromIdCard(idCard){
        const birthday = idCard.match(/\d{6}(\d{4})(\d{2})(\d{2})/);
        if (birthday) {
          const year = parseInt(birthday[1]);
          const month = parseInt(birthday[2]); //0124 1
          // const day = parseInt(birthday[3]);
          const today = new Date();
          let age = today.getFullYear() - year;
          //0 12
          // if (today.getMonth() <  month - 1 || (today.getMonth() == month - 1 && today.getDate() < day)) {
          if (today.getMonth() <  month - 1) {
            age--;
          }
          return age;
        } else {
          return -1; // 身份证号不合法
        }
    },
    // 重置表单
    resetForm() {
      this.formModel.oldmanName = '';
      this.formModel.location = '';
      this.formModel.pageNum = 1;
      this.fetchData();
    },

    // 查询数据
    async fetchData() {
      try {
        this.loading = true;
        const res = await this.$postJson('dmc/location/queryDeviceListWithPage', {
          pageNum: this.formModel.pageNum,
          oldmanName: this.formModel.oldmanName.trim(),
          location: this.formModel.location.trim(),
          pageSize: this.formModel.pageSize
        });

        // 处理响应数据（兼容可能的null/undefined）
        const list = res.result.list || [];
        list.forEach(item => {
          // 处理设备列表
          item.commonDeviceVos = item.deviceNames 
            ? item.deviceNames.split(',').filter(name => name.trim()) 
            : [];
          
          // 处理身份证信息
          if (item.oldIdCard) {
            try {
              item.age = this.getAgeFromIdCard(item.oldIdCard);
              item.sex = this.getSexFromIdCard(item.oldIdCard);
            } catch (e) {
              console.warn('身份证解析失败:', e);
              item.age = '--';
              item.sex = 0; // 默认男
            }
          } else {
            item.age = '--';
            item.sex = 0;
          }
        });

        this.renderData = list;
        this.totalData = Number(res.result.total) || 0;
      } catch (error) {
        console.error('查询数据失败:', error);
        ElMessage.error('数据加载失败，请刷新重试');
        this.renderData = [];
        this.totalData = 0;
      } finally {
        this.loading = false;
      }
    },

    // 初始化加载所有数据（包括统计数据）
    async fetchAllData() {
      try {
        this.loading = true;
        // 并行请求表格数据和设备统计数据
        const [tableRes, deviceRes,onlineRes] = await Promise.all([
          // 查询表格数据
          this.$postJson('dmc/location/queryDeviceListWithPage', {
            pageNum: this.formModel.pageNum,
            pageSize: this.formModel.pageSize
          }),
          // 查询设备总数
          this.$postJson('dmc/commonDevice/queryDeviceListWithPage', {
            pageNum: 1,
            pageSize: 1
          }),   
          // 查询设备总数
          this.$postJson('dmc/commonDevice/queryDeviceListWithPage', {
            pageNum: 1,
            online: 1,
            pageSize: 1
          })


        ]);

        // 处理表格数据
        const tableList = tableRes.result.list || [];
        tableList.forEach(item => {
          item.commonDeviceVos = item.deviceNames 
            ? item.deviceNames.split(',').filter(name => name.trim()) 
            : [];
          
          if (item.oldIdCard) {
            try {
              item.age = this.getAgeFromIdCard(item.oldIdCard);
              item.sex = this.getSexFromIdCard(item.oldIdCard);
            } catch (e) {
              item.age = '--';
              item.sex = 0;
            }
          } else {
            item.age = '--';
            item.sex = 0;
          }
        });

        this.renderData = tableList;
        this.totalData = Number(tableRes.result.total) || 0;

        // 处理设备统计数据
        const totalDeviceNum = Number(deviceRes.result.total) || 0;
        const onlineDeviceNum = Number(onlineRes.result.total) || 0; // 原逻辑：在线设备数=总数
        const onlineRate = totalDeviceNum > 0 
          ? Math.round((onlineDeviceNum / totalDeviceNum) * 100) 
          : 0;

        // 更新统计面板
        this.links = [
          {
            title: '设备覆盖人数',
            img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/288b89194e657603ff40db39e8072640.svg~tplv-49unhts6dw-image.image',
            value: this.totalData,
            unit: '人'
          },
          {
            title: '设备总数',
            value: totalDeviceNum,
            img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/fdc66b07224cdf18843c6076c2587eb5.svg~tplv-49unhts6dw-image.image',
            unit: '台'
          },
          {
            title: '在线设备数',
            value: onlineDeviceNum,
            img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/c8b36e26d2b9bb5dbf9b74dd6d7345af.svg~tplv-49unhts6dw-image.image',
            unit: '台'
          },
          {
            title: '在线设备率',
            value: onlineRate,
            img: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/c8b36e26d2b9bb5dbf9b74dd6d7345af.svg~tplv-49unhts6dw-image.image',
            unit: '%'
          }
        ];
      } catch (error) {
        console.error('初始化数据失败:', error);
        ElMessage.error('初始化失败，请刷新重试');
        this.renderData = [];
        this.totalData = 0;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px 20px 20px 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 64px); // 适配顶部导航栏高度
}

/* 面包屑样式 */
.breadcrumb {
  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      color: #666;
      &:hover {
        color: #409eff;
      }
    }
    .el-breadcrumb__separator {
      color: #999;
    }
  }
}

/* 统计面板样式 */
.panel {
  .panel-col {
    .panel-item {
      background: #ffffff;
      padding: 16px;
      border-radius: 8px;
      transition: all 0.3s;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }

    .statistic-container {
      .statistic-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 4px;
      }

      .statistic-value {
        font-size: 22px;
        font-weight: 600;
        color: #333;
        display: flex;
        align-items: baseline;

        .unit {
          font-size: 14px;
          color: #666;
          margin-left: 4px;
          font-weight: normal;
        }

        .up-icon {
          color: #f56c6c;
          margin-left: 4px;
          font-size: 16px;
        }
      }
    }
  }
}

/* 搜索表单样式 */
.search-form {
  .el-form-item {
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 0;
  }
}

/* 表格样式 */
.el-table {
  background-color: #ffffff;
  .el-table__fixed {
    height: 100% !important;
    background-color: #ffffff;
  }
  .el-table__header th {
    background-color: #f8f9fa;
  }
}

/* 空状态样式 */
.empty-state {
  .el-empty {
    width: 100%;
  }
}

/* 响应式调整 */
.panel-col {
    margin-bottom: 16px;
}


</style>